import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "../store/authStore";

const AuthLayout = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuthStore();

  // Add debug logging
  console.log('AuthLayout render - isAuthenticated:', isAuthenticated, 'location:', location.pathname);

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate
      to="/login"
      replace
      state={{ from: location }} // <-- current location so login can redirect back is desired
    />
  );
};

export default AuthLayout;
